import React, { FC } from 'react';
import { Typography, Box } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { Time } from 'models/workflow-step';

type TimeInStepProps = {
    timeSpent: Time;
    maxHourInStep: number;
};

const TimeInStep: FC<TimeInStepProps> = ({ timeSpent, maxHourInStep }: TimeInStepProps) => {
    const totalMinutes =
        (timeSpent?.hours || 0) * 60 + (timeSpent?.minutes || 0) + Math.round((timeSpent?.seconds || 0) / 60);
    const hoursSpent = Math.floor(totalMinutes / 60);
    const minutesSpent = totalMinutes % 60;
    const showWarning = maxHourInStep > 0 && hoursSpent > maxHourInStep;
    const daysSpent = Math.floor(hoursSpent / 24);
    const remainderHours = hoursSpent % 24;
    const formatTime = () => {
        if (daysSpent > 0) return `${daysSpent}d ${remainderHours}h`;
        if (hoursSpent > 0) return `${hoursSpent}h ${minutesSpent}m`;
        return `${minutesSpent}m`;
    };
    const formatted = formatTime();

    return (
        <Box display="flex" alignItems="center">
            {showWarning ? <WarningIcon color="warning" fontSize="small" sx={{ marginRight: 1 }} /> : undefined}
            <Box>
                <Typography variant="body2" sx={{ color: showWarning ? 'warning.main' : '' }}>
                    {formatted}
                </Typography>
            </Box>
        </Box>
    );
};

export default TimeInStep;
